
angular.module('bmsApp.employeeAttendanceRecord').factory('EmployeeAttendanceRecordSvc', function (CRUDSvc, EMPLOYEE_ATTENDANCE_RECORD_API) {

	return {
		index: function (params) {
			var paramsCopy = angular.copy(params);
			return CRUDSvc.get(EMPLOYEE_ATTENDANCE_RECORD_API.INDEX, paramsCopy);
		},
		date: function (params) {
			return CRUDSvc.get(EMPLOYEE_ATTENDANCE_RECORD_API.DATE_READ, params);
		},
		dateSave: function (employee_attendance_records) {
			return CRUDSvc.post(EMPLOYEE_ATTENDANCE_RECORD_API.DATE_SAVE, employee_attendance_records);
		},
		employeeNonAttendanceReasonOptions: function () {
			return CRUDSvc.get(EMPLOYEE_ATTENDANCE_RECORD_API.NON_ATTENDANCE_REASON_OPTIONS);
		},
		byEmployee: function (employeeId, params) {
			var paramsCopy = angular.copy(params);
			angular.extend(paramsCopy, {
				filter: {
					employee: employeeId
				}
			});
			var query = $.param(paramsCopy);
			return CRUDSvc.get(EMPLOYEE_ATTENDANCE_RECORD_API.INDEX + '?' + query);
		},
		unfilledDateOptions: function () {
			return CRUDSvc.get(EMPLOYEE_ATTENDANCE_RECORD_API.UNFILLED_DATE_OPTIONS);
		},
		nonAttendanceCalendarEvents: function (params) {
			return CRUDSvc.get(EMPLOYEE_ATTENDANCE_RECORD_API.NON_ATTENDANCE_CALENDAR_EVENTS, params);
		}
	};

}).constant('EMPLOYEE_ATTENDANCE_RECORD_API', {
	INDEX: 'api/employeeAttendance/index',
	DATE_READ: 'api/employeeAttendance/date/read',
	DATE_SAVE: 'api/employeeAttendance/date/save',
	NON_ATTENDANCE_REASON_OPTIONS: 'api/employeeNonAttendanceReason/options',
	EMPLOYEE: 'api/employeeAttendance/employee',
	UNFILLED_DATE_OPTIONS: 'api/employeeAttendance/unfilledDateOptions',
	NON_ATTENDANCE_CALENDAR_EVENTS: 'api/employeeAttendance/nonAttendanceCalendarEvents'
});
